// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__3ZR4D","actionsCol":"EnrolledClinics_actionsCol__1dOkm"};